const DEFAULT_MP_APP_ID = 'wx2a1e0d328ba08e92'

const getOfficialAccountAppId = () => DEFAULT_MP_APP_ID

module.exports = {
  DEFAULT_MP_APP_ID,
  getOfficialAccountAppId
}
